import useSurveyProvider from 'providers/SurveyProvider';
import { useEffect, useState } from 'react';

const Countdown = () => {
    const { remainingTime } = useSurveyProvider();
    var min = Math.floor((remainingTime % 3600) / 60);
    var sec = Math.floor((remainingTime % 3600) % 60);

    function pad2(number) {
        return (number < 10 ? '0' : '') + number;
    }
    return (
        <div className="stopwatch">
            <div className="numbers time-remaining">
                Estimated Time Remaining : <span>{pad2(min)} min </span>
                <span>{pad2(sec)} sec</span>
            </div>
        </div>
    );
};

export default Countdown;
